import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class DriverLogReportStore {
  loading = false;
  total = 0;
  driverLogData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      driverLogData: observable,
      tripData: observable,

      loadData: action,
      loadDriverLogData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=driverLogReport",
        "postData=" + base64Input
      );

    this.driverLogData = response?.data?.data?.driverLogReport;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async loadDriverLogData({ driverId, fromDate, toDate, companyId }) {
    this.loading = true;
    var postData = {
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      companyId: companyId,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=getDriversTripDetails",
        "postData=" + base64Input
      );

    this.tripData = response?.data?.data;

    this.loading = false;
  }

  async exportExcel(getData) {
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportDriverLogExcel&cid=" +
      getData.companyId +
      "&driverId=" +
      getData.driverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId=" +
      getData.userId +
      "&isadmin=" +
      getData.isadmin +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportDriverLogPdf&cid=" +
      getData.companyId +
      "&driverId=" +
      getData.driverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&userId=" +
      getData.userId +
      "&isadmin=" +
      getData.isadmin +
      "&colList=" +
      getData.colList;
  }
}

export default DriverLogReportStore;
